<ul class="account-links" role="list">
<ng-container *ngFor="let featuredContent of featuredContents">
   <ng-container *ngFor="let featuredItem of featuredContent.featuredItems">
      <li *ngIf="featuredItem?.title">
        <a [href]='featuredItem.link'
           [target]="featuredItem.target"
           [ngClass]="{'fw-600': compactHeader}"
           class="btn btn-link btn-header hidden-xs text-uppercase account-link font-secondary featured-link"
           [id]='"header-featured-link-" + (featuredItem?.title | slugify)'>
           {{featuredItem.title}}
        </a>
      </li>
   </ng-container>
</ng-container>

<ng-container *ngIf='account?.isInstantiated && (breakPointService.isDesktop$ | async)'>
  <li *ngIf="!compactAccountMenu">
    <a [routerLink]="['/account', 'profile']" [ngClass]="{'fw-600': compactHeader}"
       class="btn btn-link btn-header text-uppercase account-link font-secondary" id="account-link-profile">
      {{'component.header.collapsible_account_menu.profile' | translate}}
    </a>
  </li>

  <li *ngIf='store.hasLoyalty && !!loyaltyPlan.id && !store.hasThirdPartyLoyalty'>
    <a [routerLink]="['/loyalty']" [ngClass]="{'fw-600': compactHeader}"
       class="btn btn-link btn-header text-uppercase account-link font-secondary"
       id="account-link-loyalty">{{loyaltyPlan.loyaltyPlanName}}</a>
  </li>

  <li *ngIf="hasActiveLoyaltySubscriptions">
    <a [routerLink]="['/premium']"
       [ngClass]="{'fw-600': compactHeader}"
       class="btn btn-link btn-header text-uppercase account-link font-secondary"
       id="account-link-premium">{{'component.header.minified_header.premium' | translate}}</a>
  </li>

  <li>
    <a [routerLink]="['/account', 'my-orders']" [ngClass]="{'fw-600': compactHeader}"
       class="btn btn-link btn-header text-uppercase account-link font-secondary account-link-order-history"
       id="account-link-order-history">{{'component.header.collapsible_account_menu.order_history' | translate}}</a>
  </li>

  <li *ngIf="!compactAccountMenu">
    <a [routerLink]="['/account', 'addresses']" [ngClass]="{'fw-600': compactHeader}"
       class="btn btn-link btn-header text-uppercase account-link font-secondary"
       id="account-link-address-book">{{'component.header.collapsible_account_menu.address_book' | translate}}</a>
  </li>

  <li *ngIf="!compactAccountMenu && (store.hasCreditCard || store.hasGiftCard)">
    <a [routerLink]="['/account', 'wallet']"
       [ngClass]="{'fw-600': compactHeader}"
       class="btn btn-link btn-header text-uppercase account-link font-secondary"
       id="account-link-wallet">{{'component.header.collapsible_account_menu.wallet' | translate}}</a>
  </li>

  <li *ngIf='!store.hasThirdPartyLoyalty'>
    <a [routerLink]="['/account', 'coupons']" [ngClass]="{'fw-600': compactHeader}"
       class="btn btn-link btn-header text-uppercase account-link font-secondary account-link-coupons"
       id="account-link-coupons">{{'component.header.collapsible_account_menu.coupons' | translate}}</a>
  </li>

  <li *ngIf="account?.hasDonations && !compactAccountMenu">
    <a [routerLink]="['/account', 'donations']" [ngClass]="{'fw-600': compactHeader}"
       class="btn btn-link btn-header text-uppercase account-link font-secondary"
       id="account-link-donations">{{'component.header.collapsible_account_menu.donations' | translate}}</a>
  </li>

  <li>
    <fts-track-order-btn *ngIf="!(isSelfOrder$ | async) && !(breakPointService.isTabletDown$ | async)"
                          class="account-link"
                          [fontWeight]="compactHeader"
                          ></fts-track-order-btn>
  </li>

  <li *ngIf="!compactAccountMenu">
    <span class='separator fw-300 font-primary account-link-separator'>|</span>
  </li>

  <li *ngIf="!compactAccountMenu">
    <button
            id="account-link-logout" [ngClass]="{'fw-600': compactHeader}"
            class='btn btn-link btn-header text-uppercase account-link font-secondary'
            (click)='handleLogout()'>{{'component.header.collapsible_account_menu.sign_out' | translate}}
    </button>
  </li>

</ng-container>

<ng-container *ngIf='!account?.isInstantiated && !(breakPointService.isTabletDown$ | async)'>
  <li>
    <a
      class='btn btn-link btn-header text-uppercase account-link font-secondary'
      id="account-link-my-orders"
      [ngClass]="{'fw-600': compactHeader}"
      [routerLink]="['/account', 'my-orders']">{{'component.header.collapsible_account_menu.my_orders' | translate}}
    </a>
  </li>

  <li *ngIf='store.hasLoyalty && !!loyaltyPlan.id && !store.hasThirdPartyLoyalty'>
    <a [routerLink]="['/loyalty']" [ngClass]="{'fw-600': compactHeader}"
       class="btn btn-link btn-header text-uppercase account-link font-secondary"
       id="account-link-loyalty-not-logged-in">{{loyaltyPlan.loyaltyPlanName}}</a>
  </li>

  <li *ngIf="hasActiveLoyaltySubscriptions">
    <a [routerLink]="['/premium']"
       [ngClass]="{'fw-600': compactHeader}"
       class="btn btn-link btn-header text-uppercase account-link font-secondary"
       id="account-link-premium">{{'component.header.minified_header.premium' | translate}}</a>
  </li>

  <li>
    <fts-track-order-btn *ngIf="!(isSelfOrder$ | async) && !(breakPointService.isTabletDown$ | async)"
                          class="account-link"
                          [fontWeight]="compactHeader"></fts-track-order-btn>
  </li>

  <ng-container *ngIf="isInHome || (!compactHeader && !(breakPointService.isMdViewport$ | async)) || (breakPointService.isDesktop$ | async) || ((breakPointService.isMdViewport$ | async) && isInIntro)">
    <li>
      <a
        class='btn btn-link btn-header text-uppercase account-link font-secondary'
        id="account-link-login"
        href="login"
        [ngClass]="{'fw-600': compactHeader}"
        (click)="$event.preventDefault(); handleLogin()">{{'component.header.collapsible_account_menu.sign_in' | translate}}
      </a>
    </li>

    <li>
      <a [routerLink]="['/register']"
         [ngClass]="{'fw-600': compactHeader}"
         class='btn btn-link btn-header text-uppercase account-link font-secondary'
         id="account-link-register">{{'component.header.collapsible_account_menu.sign_up' | translate}}</a>
    </li>
  </ng-container>
</ng-container>
</ul>
